import { Link } from 'react-router-dom';
import dataReportImage from '../../../../../../assets/reports/data_report.png';

// currently not used
// const dataReportPDF =
//   process.env.PUBLIC_URL + '/static/media/data_report.0c3883b0db2eda6b39f4.pdf';

// const dataReportXLSX =
//   process.env.PUBLIC_URL +
//   '/static/media/data_report.fbab21f2c47f0e67bc1a.xlsx';

export function DataReportSection() {
  return (
    <>
      <h2>Data Report</h2>
      <p>
        A Metocean Assessment Data Report provides a fast, efficient, and economical starting point
        for any concept/basic/pre-FEED offshore design assessments.
        <Link to={'/contact'}> Contact</Link> our team for any inquiries.
      </p>
      <ul>
        <li>Semi-automated metocean data report</li>
        <li>Wind, waves, currents & water level</li>
        <li>Normal & extreme conditions</li>
        <li>Anywhere in the world</li>
        <li>Compliant with IEC and DNV standards</li>
        <li>Formats: PDF & Excel (.xlsx)</li>
        <li>Fast delivery (&lt; 5 days)</li>
      </ul>
      <img src={dataReportImage} width={960} alt="" />
    </>
  );
}
